import * as React from 'react';
import { Link } from 'react-router';
import styled, { keyframes } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexColCenter, FlexBetween } from '../../Defaults/Flexbox/Flexbox';
// import { __ } from 'react-i18n';
import { ProductPriceCart } from './ProductPriceCart';
import { TagType, Tag } from './Tag';
// import { FreeDelivery } from './FreeDelivery';
import { getProductDefaultInfo } from '../../../utilities/selectors';
// import { OrderNrInput } from './OrderNrInput';
import { StockInfo } from './StockInfo';

export interface Props {
  addToRequest: any;
  addToCart: any;
  product: any;
  isPriceWithVat?: boolean;
}

function ProductTabDefault({
  addToCart,
  addToRequest,
  product,
  isPriceWithVat,
}: Props) {
  const [orderNr, setOrderNr] = React.useState('');
  const {
    onStock,
    picture,
    url,
    name,
    price,
    priceWithoutVat,
    oldPrice,
    unit,
    ordernr: currentOrdernr,
    issaleout,
    is_new,
  } = getProductDefaultInfo(product);

  return (
    <Wrapper>
      <TopBorder />
      <RightBorder />
      <NameWrapper to={url}>
        <Name>{name}</Name>
      </NameWrapper>
      <TagsWrapper>
        {issaleout ? (
          <Tag type={TagType.SALE} text={'Výpredaj'} />
        ) : is_new ? (
          <Tag type={TagType.NEW} text={'Novinka'} />
        ) : (
          <HiddenTag />
        )}

        {/* currently turned off, turn off when API is available*/}
        {/*{false &&
          {
            <FreeDelivery />
          }}*/}
      </TagsWrapper>
      <ImageColorWrapper>
        {product.goods.length > 1 ? (
          <ColorWheelWrapper>
            <ColorWheel
              src={'/images/zemplin/color_wheel.svg'}
              alt={'Tovar v rôznych farbách, či velkostiach'}
              title={'Tovar v rôznych farbách, či velkostiach'}
            />
          </ColorWheelWrapper>
        ) : (
          <HiddenTag />
        )}
        <ImageWrapper>
          <ImageLink to={url}>
            <Image alt={`Obrázok ku produktu ${name}`} src={picture} />
          </ImageLink>
        </ImageWrapper>
      </ImageColorWrapper>
      <StockInfo onStock={onStock} unit={unit} />
      <ProductPriceCart
        price={isPriceWithVat ? price : priceWithoutVat}
        oldPrice={oldPrice}
        unit={unit}
        addToRequest={addToRequest}
        addToCart={addToCart}
      />
    </Wrapper>
  );
}

export const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexColCenter)`
  animation: ${animateIn} 0.3s ease;
  width: 100%;
  min-width: ${rem(250)};
  max-width: 31.5%;
  margin: 0 ${rem(24)} 0 0;
  padding: ${rem(48)} ${rem(32)} ${rem(48)} ${rem(8)};
  border-radius: ${rem(2)};
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;
  justify-content: space-between;

  &:nth-child(3n) {
    margin-right: 0;
    padding-right: ${rem(8)};

    ${({ theme }) => theme.mediab.l1300`
      margin-right: ${rem(24)};
      padding-right: ${rem(48)};
    `}

    ${({ theme }) => theme.mediab.m810`
      margin-right: 0;
      padding-right:  ${rem(8)};
    `}
  }

  &:first-child,
  &:nth-child(2),
  &:nth-child(3) {
    padding-top: 0;

    ${({ theme }) => theme.mediab.l1300`
      padding-top: ${rem(48)};
      &:first-child,
      &:nth-child(2) {
        padding-top: 0;
      }
    `}

    ${({ theme }) => theme.mediab.m810`
      padding-top: ${rem(32)};

      &:first-child,
      &:nth-child(2) {
        padding-top: ${rem(32)};
      }
    `}
  }

  &:first-child > :first-child,
  &:nth-child(2) > :first-child,
  &:nth-child(3) > :first-child,
  &:nth-child(3n) > :nth-child(2) {
    border: 0;
  }

  ${({ theme }) => theme.mediab.l1300`
    max-width: 47%;

    &:nth-child(2n) {
      margin-right: 0;
      padding-right: ${rem(8)};
    }

    &:nth-of-type(3) > :first-child {
      border-top: ${theme.borders.primary};
    }

    &:nth-child(3n) > :nth-child(2) {
      border-right: ${theme.borders.primary};
    }

    &:first-child > :first-child,
    &:nth-child(2) > :first-child,
    &:nth-child(2n) > :nth-child(2) {
      border: 0;
    }
  `}

  ${({ theme }) => theme.mediab.m810`
    width: 46%;
    max-width: initial;
    min-width: initial;
    padding-bottom: ${rem(32)};

    & > :nth-child(2)  {
      border: 0;
    }

    &:nth-child(2n) {
      margin-right: 0;
      padding-right: 0;
    }

    &:first-child > :first-child,
    &:nth-child(2) > :first-child,
    &:nth-child(2n) > :nth-child(2) {
      border-right: 0;
      border-top: ${theme.borders.primary};
    }

    &:first-child > :nth-child(2), &:nth-child(3n) > :nth-child(2) {
      border-right: 0;
    }

    &:last-child {
      border-bottom: ${theme.borders.primary};
    }
  `}
  ${({ theme }) => theme.mediab.m580`
    width: 100%;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
    
  `}
`;
const ImageColorWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const ColorWheelWrapper = styled.div`
  position: absolute;
  margin-top: 12px;
`;

const ColorWheel = styled.img``;

const Image = styled.img`
  width: ${rem(160)};
  height: ${rem(160)};
  margin-bottom: ${rem(41)};
  transition: transform 0.2s;

  &:hover {
    transform: scale(0.9);
  }
`;

const ImageLink = styled(Link)`
  display: table;
  margin: 0 auto;
`;

const ImageWrapper = styled.div`
  position: relative;
  display: table;
  width: 100%;
  margin: 0 auto;
`;

const TopBorder = styled.div`
  border-top: ${({ theme }) => theme.borders.primary};
  position: absolute;
  left: 2%;
  right: 6%;
  top: 0;

  ${({ theme }) => theme.mediab.m810`
      left: 1%;
      right: 1%;
  `};
`;

const RightBorder = styled.div`
  border-right: ${({ theme }) => theme.borders.primary};
  position: absolute;
  bottom: 8%;
  top: 8%;
  right: 0;
`;

const NameWrapper = styled(Link)`
  width: 100%;
  text-decoration: none;
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-bottom: ${rem(12)};
  color: ${({ theme }) => theme.colors.black};
  text-align: left;
  width: 100%;
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 400;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${rem(8)};
  `}
`;

const TagsWrapper = styled(FlexBetween)`
  width: 100%;
  margin: ${rem(2)} 0;
  position: relative;

  ${({ theme }) => theme.mediab.m810`
      display: none;
  `}
`;

const SecondaryText = styled(TextP)`
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${rem(12)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.placeholder};
`;
const HiddenTag = styled.div`
  height: 26px;
  width: 100%;
  visibility: hidden;
`;

export { ProductTabDefault };
